// Franja de contexto del cliente, debajo de la topbar y sobre la card del paso. El teléfono que el
// vendedor tecleó en el paso 01 queda a la vista en los 10 pasos, así no se pierde a quién le vende.
// El nombre se suma cuando el KYC lo devuelve: antes del paso 02 no existe y la franja va sin él.
import { formatPhone } from '../phoneFormat';
import type { WizardSession } from '../types';

export function WizardClientBar({ session }: { session: WizardSession }) {
    const clientName = session.kyc.verified?.fullName ?? session.firstName;

    return (
        <div className="flex flex-none items-center gap-2 border-b border-border bg-card px-3 py-1.5 sm:px-5">
            <span className="flex-none text-[10px] font-semibold uppercase tracking-[0.08em] text-muted-foreground">
                Cliente
            </span>
            {clientName && (
                <>
                    <span className="truncate text-[12px] font-semibold">{clientName}</span>
                    <span className="flex-none text-border">·</span>
                </>
            )}
            <span className="flex-none text-[12px] font-medium tabular-nums">
                {formatPhone(session.phone)}
            </span>
        </div>
    );
}
